import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { DataCardSkeleton, ProfileCardSkeleton } from '@/components/charts/ChartSkeleton';

export const DashboardSkeleton: React.FC = () => (
  <div className="space-y-6 p-4 md:p-6 pb-20 md:pb-6">
    {/* Header */}
    <div className="space-y-2">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-4 w-64" />
    </div>

    {/* Quick Stats */}
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
      {[...Array(4)].map((_, i) => (
        <DataCardSkeleton key={i} />
      ))}
    </div>

    {/* Recent Activity */}
    <div className="space-y-4">
      <Skeleton className="h-6 w-32" />
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => (
          <ProfileCardSkeleton key={i} />
        ))}
      </div>
    </div>
  </div>
);
